var chunkToChildrenMap = {
	"src_myspace_index_jsx": [
		"webpack_container_remote_base_stores",
		"webpack_container_remote_widgets_inputs",
		"webpack_container_remote_base_utils",
		"webpack_container_remote_widgets_datadisplay",
		"webpack_container_remote_base_i18n",
		"webpack_container_remote_widgets_layouts",
		"webpack_container_remote_widgets_feedback",
		"webpack_container_remote_widgets_infinitescroll",
		"webpack_container_remote_widgets_flowicon",
		"webpack_container_remote_widgets_newflowcontainer",
		"webpack_container_remote_widgets_lazyremote",
		"webpack_container_remote_widgets_datetime",
		"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_objectWithoutPr-4e96f4",
		"src_myspace_myitems_index_jsx-src_myspace_shared_components_date_field_styles_css-src_myspace-7e5d06",
		"src_myspace_mytasks_index_jsx-src_myspace_shared_components_date_field_styles_css-src_myspace-521e12",
		"src_myspace_admin_tasks_index_jsx"
	],
	"src_myspace_admin_tasks_index_jsx": [
		"webpack_container_remote_base_stores",
		"webpack_container_remote_widgets_inputs",
		"webpack_container_remote_base_utils",
		"webpack_container_remote_widgets_layouts",
		"webpack_container_remote_widgets_feedback",
		"webpack_container_remote_widgets_infinitescroll",
		"webpack_container_remote_widgets_modal",
		"webpack_container_remote_base_rtdb",
		"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_asyncToGenerato-96ed2a",
		"src_myspace_admin_assignment_index_jsx-src_myspace_shared_components_flow_card_style_css-src_-6b9032",
		"src_myspace_item_reassignment_index_jsx-src_myspace_shared_components_flow_card_style_css-src-304e05",
		"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_asyncToGenerato-a5e2cb",
		"src_myspace_flow_approval_index_jsx-src_myspace_shared_components_flow_card_style_css-src_mys-bb798c",
		"src_myspace_join_requests_index_jsx-src_myspace_shared_components_flow_card_style_css-src_mys-ff4ced"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };